import { render, staticRenderFns } from "./TargetBuildFailedTests.vue?vue&type=template&id=783efed2&scoped=true"
import script from "./TargetBuildFailedTests.vue?vue&type=script&lang=js"
export * from "./TargetBuildFailedTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783efed2",
  null
  
)

export default component.exports